import api from './api';

const supportService = {
  // USER METHODS
  createTicket: async (formData) => {
    // Note: formData car on peut envoyer une image
    // On utilise api.request car api.post fait un JSON.stringify par défaut
    const response = await api.request('/support', {
      method: 'POST',
      body: formData
    });
    return response;
  },

  getUserTickets: async () => {
    const response = await api.get('/support');
    return response;
  },

  getTicketMessages: async (ticketId) => {
    const response = await api.get(`/support/${ticketId}/messages`);
    return response;
  },

  replyToTicket: async (ticketId, formData) => {
    const response = await api.request(`/support/${ticketId}/reply`, {
      method: 'POST',
      body: formData
    });
    return response;
  },

  // ADMIN METHODS
  getAllTickets: async (status) => {
    const query = status ? `?status=${status}` : '';
    const response = await api.get(`/support/admin/tickets${query}`);
    return response;
  },

  adminReplyToTicket: async (ticketId, message) => {
    const response = await api.post(`/support/admin/${ticketId}/reply`, { message });
    return response;
  },

  updateTicketStatus: async (ticketId, status) => {
    const response = await api.put(`/support/admin/${ticketId}/status`, { status });
    return response;
  }
};

export default supportService;
